import { useTranslation } from 'react-i18next';
import { CheckCircle2, Circle } from 'lucide-react';

export function CredentialsStatusBadge({ isConfigured }: { isConfigured: boolean }) {
  const { t } = useTranslation();
  if (isConfigured) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700">
        <CheckCircle2 className="h-3.5 w-3.5" aria-hidden="true" />
        {t('platform_admin.tenant_detail.credentials.status_connected')}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-neutral-200 bg-neutral-100 px-2.5 py-1 text-xs font-medium text-neutral-600">
      <Circle className="h-3.5 w-3.5" aria-hidden="true" />
      {t('platform_admin.tenant_detail.credentials.status_not_configured')}
    </span>
  );
}
